// frontend/src/context/AGTFitProContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import proService from '../service/agtfitProService';

const AGTFitProContext = createContext();

export function useAGTFitProContext() {
  return useContext(AGTFitProContext);
}

export function AGTFitProProvider({ children }) {
  const [isPro, setIsPro] = useState(false);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const checkProStatus = async () => {
      setLoading(true);
      try {
        const user = auth.currentUser;
        if (user) {
          const status = await proService.checkProStatus();
          setIsPro(status.isPro);
        } else {
          setIsPro(false);
        }
      } catch (error) {
        console.error('Error checking AGTFit PRO status:', error);
        setIsPro(false);
      } finally {
        setLoading(false);
      }
    };

    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        checkProStatus();
      } else {
        setIsPro(false);
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  const value = {
    isPro,
    loading,
    refreshProStatus: async () => {
      try {
        const status = await proService.checkProStatus();
        setIsPro(status.isPro);
      } catch (error) {
        console.error('Error refreshing AGTFit PRO status:', error);
      }
    }
  };

  return (
    <AGTFitProContext.Provider value={value}>
      {children}
    </AGTFitProContext.Provider>
  );
}